import { Box, Typography } from "@mui/material";
import DOMPurify from "dompurify";
import { FC } from "react";

import ActiveFormPreviewMUI from "web/Layout/SubscriptionReceivers/SubscriptionReceiverForm/ActiveFormPreview/activeFormPreviewMUI";
import __ from "web/Layout/Translations";

import Dialog from "web/Components/mui/Dialog";

interface ISubscriptionReceiverPreviewMUI {
  open: boolean;
  onClose: () => void;
  isMobile: boolean;
  groupName: string;
  subscriptionName: string;
  description?: string;
  formData: any;
  configuration: any[];
}

const SubscriptionReceiverFormDialogPreview: FC<
  ISubscriptionReceiverPreviewMUI
> = ({
  open,
  onClose,
  isMobile,
  groupName,
  subscriptionName,
  description,
  formData,
  configuration,
}) => (
  <Dialog
    sx={{
      "& .MuiDialog-paper": {
        maxWidth: isMobile ? "100%" : "784px",
      },
      ...(!isMobile && {
        ".MuiDialogContent-root, & .MuiDialogTitle-root": {
          p: 0,
        },
        ".MuiDialogTitle-root": {
          pb: 3,
        },
      }),
      ...(isMobile && {
        ".MuiDialogContent-root": {
          backgroundColor: "#FAFAFA",
          padding: "0 !important",
        },
        ".MuiTypography-root": {
          zIndex: 100,
        },
        ".MuiButtonBase-root": {
          zIndex: 200,
        },
      }),
    }}
    fullScreen={isMobile}
    open={open}
    onClose={onClose}
    title={__("Podgląd formularza")}
  >
    <Box
      sx={{
        ...(isMobile && {
          pt: 2,
          px: 2,
        }),
      }}
    >
      <Typography variant="subtitle1" mb={1}>
        {groupName}
      </Typography>
      <Typography variant="h6" mb={2}>
        {subscriptionName}
      </Typography>
      {description && (
        <Typography
          variant="body2"
          mb={3}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(description),
          }}
        />
      )}
    </Box>

    <ActiveFormPreviewMUI
      configuration={configuration}
      formData={formData}
      isMobile={isMobile}
      closeHandler={onClose}
    />
  </Dialog>
);

export default SubscriptionReceiverFormDialogPreview;
